import { render, staticRenderFns } from "./data-management-containers.vue?vue&type=template&id=66636278&"
import script from "./data-management-containers.vue?vue&type=script&lang=js&"
export * from "./data-management-containers.vue?vue&type=script&lang=js&"
import style0 from "./data-management-containers.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports